<template>
<v-container ma-0 pa-0>
    <slot name="back"></slot>
    <v-layout class="px-0 py-3 pl-4"  align-start wrap row>
        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md4>

            <p><strong>Estratégia</strong> {{current_strategy && current_strategy.name }} </p>
            <!-- <p><strong>Público</strong> {{`${setContactScore(current_strategy.contact_score)}`}} ({{current_strategy.contact_score}}) </p> -->
            <p><strong>Credor</strong>  {{current_creditor}} </p>
            <p><strong>Abordagem</strong>  {{current_strategy && current_strategy.approach && current_strategy.approach.name}} 
                ({{current_strategy && current_strategy.approach &&  current_strategy.approach.type}})</p>
            <!-- <p><strong>Máximo de contatos</strong>  {{current_strategy.max_contacts_count}} </p> -->
            <p><strong>Máximo de notificações</strong>  {{current_strategy.max_notifications ? current_strategy.max_notifications : '-'}} </p>
            <p><strong>Dias de espera</strong>  {{current_strategy.days_to_wait}} </p>
            
            <p><strong>Última importação</strong>  {{current_strategy.last_import_since | formatDateTime}} </p>
            <p><strong>Limite no disparo</strong>  {{current_strategy.limit ? current_strategy.limit : '-'}} </p>

            <p><strong>Pessoa física</strong>  {{current_strategy.personal ? 'Sim' : 'Não'}} </p>
            <p><strong>Pessoa jurídica</strong>  {{current_strategy.business ? 'Sim' : 'Não'}} </p>
            <p><strong>Apenas negociações prorrogadas</strong>  {{current_strategy.only_waiting_deals ? 'Sim' : 'Não'}} </p>
        </v-flex>

        <v-flex xs12 sm6 md4>
            <p><strong>Máximo de saldo devedor</strong>  {{current_strategy.max_debit ? current_strategy.max_debit : '-'}} </p>
            <p><strong>Mínimo de saldo devedor</strong>  {{current_strategy.min_debit ? current_strategy.min_debit : '-'}} </p>
            
            <p><strong>Boleto</strong>  {{current_strategy.boleto ? 'Sim' : 'Não'}} </p>
            <p><strong>Débito automático</strong>  {{current_strategy.debit_card ? 'Sim' : 'Não'}} </p>
            <!-- <p><strong>Estados</strong>  {{current_strategy.states}} </p> -->
            <p><strong>Contato próprio</strong>  {{current_strategy.owner ? 'Sim' : 'Não'}} </p>
            <p><strong>Contato sócios</strong>  {{current_strategy.associate ? 'Sim' : 'Não'}} </p>
            <p><strong>Contato avalistas</strong>  {{current_strategy.guarantor ? 'Sim' : 'Não'}} </p>
            <p><strong>Qualidade máxima de contatos</strong>  {{current_strategy.contact_max_final_score ? current_strategy.contact_max_final_score : '-'}} </p>
            <p><strong>Qualidade mínima de contatos</strong>  {{current_strategy.contact_min_final_score ? current_strategy.contact_min_final_score : '-'}} </p>
            <p><strong>Máximo de dias de atraso</strong>  {{current_strategy.max_days_of_delay ? current_strategy.max_days_of_delay : '-'}} </p>
            <p><strong>Mínimo de dias de atraso</strong>  {{current_strategy.min_days_of_delay ? current_strategy.min_days_of_delay : '-'}} </p>
        </v-flex>
        <v-flex xs12 sm6 md4>
            <p><strong>Políticas</strong>  {{current_strategy.policies ? current_strategy.policies : '-'}} </p>

            <!-- <p><strong>Tags da Contato</strong>  {{current_strategy.contact_tags ? current_strategy.contact_tags : '-'}} </p>
            <p><strong>Tags de negociação</strong>  {{current_strategy.tags ? current_strategy.tags : '-'}} </p>


            <p><strong>Aplicar tags</strong>  {{current_strategy.apply_tags ? 'Sim' : 'Não'}} </p> -->

            <p><strong>Data da safra</strong>  {{current_strategy.contact_date | formatDateTime}} </p>
<!-- 
            <p><strong>Origem Cliente</strong>  {{current_strategy.customer ? 'Sim' : 'Não'}} </p>
            <p><strong>Origem Credor</strong>  {{current_strategy.creditor ? 'Sim' : 'Não'}} </p>
            <p><strong>Origem Operador</strong>  {{current_strategy.operator ? 'Sim' : 'Não'}} </p>
            <p><strong>Origem Parceiro</strong>  {{current_strategy.partner ? 'Sim' : 'Não'}} </p> -->

            <p><strong>Última notificação</strong>  {{current_strategy.last_notified_at | formatDateTime}} </p>
            <p><strong>Notificações no último de disparo</strong> {{current_strategy.last_notification_count ? current_strategy.last_notification_count : '-'}} </p>


        </v-flex>
<v-spacer></v-spacer>



    </v-layout> 
</v-container>
</template>

<script>


export default {
    props: {
        strategy: {
            default () {
                return {
                    approach:{},
                    creditor:{},
                };
            }
        },
        creditor: {
            default () {
                return {
                    creditor_name:{},
                };
            }
        },
    },
    async created() {
        
    },
    async mounted() {},
    watch:{
        strategy: {
            async handler() {
                if(typeof(this.strategy) === 'string'){
                    this.current_strategy = JSON.parse(this.strategy)
                }
                else if(typeof(this.strategy) === 'object'){
                    let current_strategy_str = JSON.stringify(this.strategy)
                    this.current_strategy = JSON.parse(current_strategy_str);
                }
                else {
                    this.current_strategy = this.strategy
                }
            },
            deep: true
        },
        creditor: {
            async handler() {
                this.current_creditor = this.creditor
            },
            deep: true
        },
    },
    data() {
        return {
            current_strategy:{
                approach:{},
                creditor:{},
                strategy_snapshot:{}
            },
            current_creditor:{
                creditor_name:{}
            }
        };
    },
    methods: {
        // setContactScore(score){
        //     if(score === 0) return 'Novos' 
        //     if(score > 0 && score < 100) return 'Receberam notificação'
        //     if(score === 100) return 'Localizados'
        //     return '-' 
        // }
    }
};
</script>
<style>

</style>
